import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col">
            <img src="/assets/img/brand/logo-light.png" alt="Unity Trademark" className="footer-logo" />
            <p className="footer-text">
              Your trusted partner for trademark registration, copyright protection, 
              and business formation services in the USA.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/trademark-registration">Trademark Registration</Link></li>
              <li><Link to="/copyright-registration">Copyright Registration</Link></li>
              <li><Link to="/company-formation">Company Formation</Link></li>
              <li><Link to="/trademark-search">Trademark Search</Link></li>
              <li><Link to="/amazon-brand-registry">Amazon Brand Registry</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Contact Info</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={18} />
                <span>info@unitytrademark.com</span>
              </li>
              <li>
                <Phone size={18} />
                <span>+1 (213) 266-5334</span>
              </li>
              <li>
                <MapPin size={18} />
                <span>2029 Century Park E<br />Los Angeles, CA 90067, USA</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Unity Trademark. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;